import { Link } from '@com-delta-idp/mnx-ui-kit';
import { AEMImage } from './common.interfaces';

export interface ActionType {
  link: Link;
  type: string;
}

export interface AEMMembershipCard {
  image: AEMImage;
  validThruLabel: string;
  altBarcodeText: string;
}

export interface AEMCard {
  id?: string;
  image: AEMImage;
  title: string;
  actionType?: ActionType;
}

export interface AEMStatus {
  cards: AEMCard[];
  medallionId: string;
  medallionLabel: string;
  membershipcard: AEMMembershipCard;
}

export interface AEMSkyClub {
  executive: string;
  expiry: string;
  individual: string;
  nonMember: string;
}

export interface AEMQuickLinks {
  action: ActionType;
  info: string;
  rules: string;
  status: AEMStatus[];
  title: string;
  barcodeUrl: string;
  skyclub: AEMSkyClub;
}
